import { Component, Output, EventEmitter, OnInit, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { CustomDataService } from "../../main/accountant/setup-and-settings/client-contact-fields/custom-data.service";
import { CommonModule, DatePipe } from "@angular/common";
import { DatePickerModule } from "primeng/datepicker";
import { DropdownModule } from "primeng/dropdown";

import { CheckboxModule } from "primeng/checkbox";
import { HotToastService } from "@ngneat/hot-toast";
import { DashboardService } from "../../dashboard.service";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { InputNumberModule } from "primeng/inputnumber";

@Component({
  selector: "app-drawer",
  imports: [
    InputTextModule,
    FormsModule,
    CommonModule,
    DatePickerModule,
    DropdownModule,
    CheckboxModule,
    BsDropdownModule,
    InputNumberModule,
  ],
  templateUrl: "./drawer.component.html",
  styleUrls: ["./drawer.component.scss"],
})
export class DrawerComponent implements OnInit {
  @Output() onHide = new EventEmitter<boolean>();
  @Output() inviteContactToBecomeClientEvent = new EventEmitter();
  @Output() removeClientUserEvent = new EventEmitter();
  @Output() removeContactEvent = new EventEmitter();

  @Input() userOrContactDrawer;
  @Input() isForClientDetails: boolean;
  @Input() isForContact: boolean;
  @Input() clientDataFieldValues;
  value;

  constructor(
    private customDataService: CustomDataService,
    private toastr: HotToastService,
    private dashboardService: DashboardService,
    public datePipe: DatePipe,
  ) {}

  ngOnInit(): void {}

  closeDrawer() {
    this.onHide.emit(false);
  }

  inviteContactToBecomeClient() {
    this.inviteContactToBecomeClientEvent.emit(this.userOrContactDrawer);
  }

  async saveChanges() {
    this.dashboardService.show_loading.next(true);
    const dataFieldValues = this.isForClientDetails
      ? this.clientDataFieldValues
      : this.userOrContactDrawer.data_field_values;
    const data = dataFieldValues.map((df) => ({
      uuid: df.uuid,
      value: df.value,
    }));
    const { message } =
      await this.customDataService.saveDataFieldValueChanges(data);
    this.dashboardService.show_loading.next(false);
    this.closeDrawer();
    this.toastr.success(message);
  }

  removeClientUser(user) {
    this.removeClientUserEvent.emit(user);
  }

  removeContact(contact) {
    this.removeContactEvent.emit(contact);
  }
}
